import React from 'react';
import { Route } from 'react-router-dom';
import * as ROUTES from '../constants/routes';
import Orders from '../screens/ManageOrderScreen/orders';
import Processing from '../screens/ManageOrderScreen/processing';
import Returns from '../screens/ManageOrderScreen/returns';

const ManageOrderRoutes = () => {
  return (
    <>
      <Route path={ROUTES.ORDERS} exact component={() => <Orders />} />
      <Route path={ROUTES.PROCESSING} exact component={() => <Processing />} />
      <Route path={ROUTES.RETURNS} exact component={() => <Returns />} />
    </>
  );
};

export default ManageOrderRoutes;
